document.addEventListener("alpine:init", () => {
  Alpine.data(
    "bundles",
    ({
      otpFirst,
      badgePattern,
      pricePattern,
      currencyDivider,
      displayCompareAtPrice,
      displaySubscriptionBadge,
      displayOTPBadge,
      mainSellingPlanId,
      alternateSellingPlanId,
      mainSellingPlanGid,
      alternateSellingPlanGid,
    }) => {
      return {
        products: [],
        flavors: [],
        currentFlavor: null,
        bundleForm: null,
        displayCompareAtPrice: displayCompareAtPrice == "true",
        displaySubscriptionBadge: displaySubscriptionBadge == "true",
        displayOTPBadge: displayOTPBadge == "true",
        badgePattern: badgePattern ?? "[amount]",
        pricePattern: pricePattern ?? "[amount]",
        currencyDivider: currencyDivider ?? 100,
        purchaseTypes: null,
        purchaseType: null,
        isSubscription: false,
        otpFirst: otpFirst || false,
        mainSellingPlanId: mainSellingPlanId ? String(mainSellingPlanId) : "10533306671",
        alternateSellingPlanId: alternateSellingPlanId ? String(alternateSellingPlanId) : "10582360367",
        mainSellingPlanGid:
          mainSellingPlanGid || "gid://shopify/SellingPlan/10533306671",
        alternateSellingPlanGid:
          alternateSellingPlanGid || "gid://shopify/SellingPlan/10582360367",
        sellingPlanTestStorageKey: "kmSellingPlanTestVariant",
        useAlternateSellingPlan: false,

        init() {
          this.bundleForm = this.$refs.bundleForm;
          this.products = JSON.parse(this.$refs.productsData.textContent);
          this.purchaseTypes = JSON.parse(this.$refs.purchaseTypes.textContent);
          this.useAlternateSellingPlan =
            window.localStorage.getItem(this.sellingPlanTestStorageKey) === "alternate";
          this.prepareFlavorsData();

          this.changeSelectedPurchaseType(
            this.otpFirst ? "otp" : "subscription"
          );

          window.addEventListener("kilgour:buybox:request-state", () => {
            this.emitStickyState();
          });

          console.log(this.products);
        },

        normalizeSellingPlanId(id) {
          if (id === null || id === undefined) return "";
          return String(id).split("/").pop();
        },

        getAllocationBySellingPlanId(allocations, sellingPlanId) {
          if (!allocations || !sellingPlanId) return null;

          const normalizedTarget = this.normalizeSellingPlanId(sellingPlanId);

          return (
            allocations.find((allocation) => {
              return (
                this.normalizeSellingPlanId(allocation.selling_plan_id) ===
                  normalizedTarget ||
                this.normalizeSellingPlanId(allocation.selling_plan?.id) ===
                  normalizedTarget
              );
            }) || null
          );
        },

        getActiveSubscriptionAllocation(flavor = this.currentFlavor) {
          if (!flavor) return null;

          if (this.useAlternateSellingPlan && flavor.selling_plan_alternate) {
            return flavor.selling_plan_alternate;
          }

          if (flavor.selling_plan_main) {
            return flavor.selling_plan_main;
          }

          return flavor.selling_plan || null;
        },

        getActiveSellingPlanId(flavor = this.currentFlavor) {
          const allocation = this.getActiveSubscriptionAllocation(flavor);
          return allocation ? allocation.selling_plan_id : "";
        },

        getActiveSellingPlanLabel(flavor = this.currentFlavor) {
          const allocation = this.getActiveSubscriptionAllocation(flavor);
          const normalizedId = this.normalizeSellingPlanId(
            allocation?.selling_plan_id || ""
          );

          if (normalizedId === this.normalizeSellingPlanId(this.alternateSellingPlanId)) {
            return "Alternate test selling plan";
          }

          if (normalizedId === this.normalizeSellingPlanId(this.mainSellingPlanId)) {
            return "Main selling plan";
          }

          return "Current product selling plan";
        },

        currentFlavorSupportsAlternateSellingPlan() {
          return !!this.currentFlavor?.selling_plan_alternate;
        },

        setSellingPlanTestVariant(variant) {
          this.useAlternateSellingPlan = variant === "alternate";
          window.localStorage.setItem(
            this.sellingPlanTestStorageKey,
            this.useAlternateSellingPlan ? "alternate" : "main"
          );
          this.updateForm();
        },

        formatBenefits(benefits) {
          if (!benefits) return "";

          let html = `<ul class="ctr-bundle__item-list">
            ${benefits
              .split("\n")
              .map((benefit) => {
                return `<li>${benefit
                  .replace(
                    "[icon-delivery]",
                    "<span class='ctr-icon m-delivery'></span>"
                  )
                  .replace(
                    "[icon-time]",
                    "<span class='ctr-icon m-time'></span>"
                  )}</li>`;
              })
              .join("")}
          </ul>`;

          return html;
        },

        prepareFlavorsData() {
          if (!this.products) return;
          this.flavors = [];

          this.products.forEach(
            ({
              product,
              metafields,
              custom_bundle_image: customBundleImage,
              custom_bundle_title: customBundleTitle,
            }) => {
              let alternativeImage = customBundleImage || null;
              const firstVariant = product.variants[0];
              const sellingPlanAllocations =
                firstVariant.selling_plan_allocations || [];
              const defaultSellingPlanAllocation = sellingPlanAllocations[0] || null;
              const mainSellingPlanAllocation =
                this.getAllocationBySellingPlanId(
                  sellingPlanAllocations,
                  this.mainSellingPlanId
                ) || defaultSellingPlanAllocation;
              const alternateSellingPlanAllocation =
                this.getAllocationBySellingPlanId(
                  sellingPlanAllocations,
                  this.alternateSellingPlanId
                ) || null;
              const initialSubscriptionAllocation =
                mainSellingPlanAllocation || defaultSellingPlanAllocation;

              const flavorImage =
                alternativeImage ||
                firstVariant.featured_image ||
                product.featured_image;

              const variantPrice = Number(firstVariant.price || 0);
              const productCompareAt = Number(product.compare_at_price || 0);
              const variantCompareAt = Number(firstVariant.compare_at_price || 0);

              const oneTimeReferencePrice =
                productCompareAt && productCompareAt > variantPrice
                  ? productCompareAt
                  : variantCompareAt && variantCompareAt > variantPrice
                    ? variantCompareAt
                    : variantPrice;

              const subscriptionPrice = Number(
                initialSubscriptionAllocation?.price || variantPrice
              );
              const subscriptionOldPrice = oneTimeReferencePrice;

              this.flavors.push({
                parentId: product.id,
                id: firstVariant.id,
                title: customBundleTitle || product.title,
                description: product.description,
                image: flavorImage,
                benefitsOtp: this.formatBenefits(
                  metafields.bundle_benefits_otp
                ),
                benefitsSubscription: this.formatBenefits(
                  metafields.bundle_benefits
                ),
                refillText: metafields.bundle_refill_text,
                link: {
                  handle: product.handle,
                  url: `/products/${product.handle}`,
                },
                prices: {
                  otp: {
                    currentPrice: firstVariant.price,
                    compareAtPrice:
                      oneTimeReferencePrice > variantPrice
                        ? oneTimeReferencePrice
                        : null,
                  },
                  subscription: {
                    currentPrice: subscriptionPrice,
                    oldPrice: subscriptionOldPrice,
                  },
                },
                savings: {
                  otp: oneTimeReferencePrice - firstVariant.price,
                  subscription: oneTimeReferencePrice - subscriptionPrice,
                },
                badge_text: (() => {
                  const otpPct = Math.round(
                    ((oneTimeReferencePrice - firstVariant.price) /
                      oneTimeReferencePrice) *
                      100
                  );

                  const subPct = Math.round(
                    ((subscriptionOldPrice - subscriptionPrice) /
                      subscriptionOldPrice) *
                      100
                  );

                  return {
                    otp:
                      otpPct > 0
                        ? `${badgePattern.replace("[percentage]", otpPct)}%`
                        : null,
                    subscription:
                      subPct > 0
                        ? `${badgePattern.replace("[percentage]", subPct)}%`
                        : null,
                  };
                })(),
                selling_plan: initialSubscriptionAllocation,
                selling_plan_main: mainSellingPlanAllocation,
                selling_plan_alternate: alternateSellingPlanAllocation,
              });
            }
          );

          this.currentFlavor = this.flavors[0];
        },

        getSubscriptionPrice(flavor = this.currentFlavor) {
          const allocation = this.getActiveSubscriptionAllocation(flavor);
          return Number(
            allocation?.price || flavor?.prices?.subscription?.currentPrice || 0
          );
        },

        getSubscriptionOldPrice(flavor = this.currentFlavor) {
          return Number(flavor?.prices?.subscription?.oldPrice || 0);
        },

        getSubscriptionSavings(flavor = this.currentFlavor) {
          const oldPrice = this.getSubscriptionOldPrice(flavor);
          const currentPrice = this.getSubscriptionPrice(flavor);
          return oldPrice && currentPrice ? oldPrice - currentPrice : 0;
        },

        getSubscriptionBadgeText(flavor = this.currentFlavor) {
          const oldPrice = this.getSubscriptionOldPrice(flavor);
          const currentPrice = this.getSubscriptionPrice(flavor);

          if (!oldPrice || !currentPrice || oldPrice <= currentPrice) return null;

          const subPct = Math.round(((oldPrice - currentPrice) / oldPrice) * 100);
          return subPct > 0
            ? `${this.badgePattern.replace("[percentage]", subPct)}%`
            : null;
        },

        emitStickyState() {
          try {
            const isSub = !!this.isSubscription;
            const price = isSub
              ? this.getSubscriptionPrice(this.currentFlavor)
              : this.currentFlavor.prices.otp.currentPrice;

            const compareAt = isSub
              ? this.getSubscriptionOldPrice(this.currentFlavor)
              : this.displayCompareAtPrice
                ? this.currentFlavor.prices.otp.compareAtPrice
                : null;

            const pct =
              compareAt && price
                ? Math.round(((compareAt - price) / compareAt) * 100)
                : null;

            const subtext =
              pct && pct > 0
                ? isSub
                  ? `Save ${pct}% with subscription`
                  : `Save ${pct}%`
                : isSub
                  ? "Subscribe & save"
                  : "";

            window.dispatchEvent(
              new CustomEvent("kilgour:buybox:change", {
                detail: {
                  title: this.currentFlavor.title,
                  variantId: String(this.currentFlavor.id),
                  sellingPlanId: isSub
                    ? String(this.getActiveSellingPlanId(this.currentFlavor))
                    : "",
                  img: this.currentFlavor.image || null,
                  formattedPrice: this.formatPrice(price),
                  formattedCompareAt: compareAt
                    ? this.formatPrice(compareAt)
                    : null,
                  subtext: subtext || null,
                },
              })
            );
          } catch (e) {}
        },

        updateForm() {
          const parentIdField = this.bundleForm.querySelector(
            'input[name="product-id"]'
          );
          const variantIdField =
            this.bundleForm.querySelector('input[name="id"]');
          const sellingPlanField = this.bundleForm.querySelector(
            'input[name="selling_plan"]'
          );

          parentIdField.value = this.currentFlavor.parentId;
          variantIdField.value = this.currentFlavor.id;
          sellingPlanField.value = this.isSubscription
            ? this.getActiveSellingPlanId(this.currentFlavor)
            : "";

          this.emitStickyState();
        },

        changeSelectedFlavor(flavorId) {
          this.currentFlavor = this.flavors.find(
            (flavor) => flavor.id == flavorId
          );

          this.updateForm();
        },

        changeSelectedPurchaseType(purchaseTypeId) {
          this.purchaseType = this.purchaseTypes.find(
            (type) => type.id === purchaseTypeId
          );

          this.isSubscription = this.purchaseType?.id === "subscription";

          this.updateForm();
        },

        formatPrice(price) {
          if (price === null || price === undefined) return "";

          return this.pricePattern.replace(
            "[amount]",
            (price / this.currencyDivider).toFixed(2)
          );
        },
      };
    }
  );
});
